import axios from 'axios';

export function getActivityStatisticsByAdvertiserId(accountId) {
  return axios.get(`/brands/${accountId}/stats/activity`);
}
